import LTR from "@brand-icons/global/chevron-circle-forward/chevron-circle-forward-ltr.svg";

import { iconFactory } from "../iconFactory";

export const ChevronCircleForwardIcon = iconFactory("ChevronCircleForwardIcon", LTR);
